 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		0: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		0: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"1":"product-option-chain-position-selectable~product-option-color-inline~product-option-color-selectable~ec876204","2":"splidejs-splide","3":"tom-select","5":"adyen-adyen-web","33":"cart-modify-option-color","34":"cart-modify-option-custom-image","35":"cart-modify-option-custom-text","36":"cart-modify-option-glass-reversed","37":"cart-modify-option-material-canvas","38":"cart-modify-option-material-color","39":"cart-modify-option-model","40":"cart-modify-option-model-size","41":"cart-modify-option-pack","42":"cart-modify-option-size","43":"cart-modify-option-support-color","44":"cart-modify-option-tissue","45":"cart-modify-option-tissue-drop","47":"header-cart-general","48":"header-cart-item-general","49":"header-cart-item-image-zoom","50":"header-cart-voucher","51":"header-left-menu-v2","145":"pinch-zoom-js","146":"popup-personalized-text","147":"product-option-chain-position-selectable","148":"product-option-color-inline","149":"product-option-color-selectable","150":"product-option-custom-image-inline","151":"product-option-custom-image-selectable","152":"product-option-custom-text-inline","153":"product-option-custom-text-selectable","154":"product-option-frame-inline","155":"product-option-glass-reversed-inline","156":"product-option-material-color-inline","157":"product-option-model-inline","158":"product-option-model-size-inline","159":"product-option-motorbike-kit-selectable","160":"product-option-orientation-inline","161":"product-option-pack-inline","162":"product-option-pack-selectable","163":"product-option-size-inline-selectable","164":"product-option-size-multiple-selectable","165":"product-option-size-selectable","166":"product-option-size-single-value","167":"product-option-size-wallpaper","168":"product-option-support-color-selectable","169":"product-option-tissue-drop-selectable","170":"product-option-tissue-selectable","171":"product-option-vinyl-rug-format-inline","172":"product-page-ar-tool","173":"product-tool-wallpaper-calculator","174":"swiper","175":"vendors~product-option-material-color-inline","176":"vertex-filters-post-render-dynamic","177":"vertex-general-combination-suggestions-dynamic"}[chunkId]||chunkId) + ".20261103_" + {"1":"2d8806ec376d5e784c53","2":"312b886bb8214fc56682","3":"a5223f6a85c05d65c824","4":"01a03e458c08e3bd3bf5","5":"955f4fd95bd6f248bfa1","6":"0641536b7958fb761ece","7":"2f8dadb4d589af364ef1","8":"00e31cc61fdb98188939","9":"89d69eacf6e3626281aa","10":"ec8e28ef99a53048ab8c","11":"db078df2d21b112e0fcd","12":"1c2232206fdfbc469ba8","13":"462552c968af7213eb90","14":"987182f044037a146aee","15":"fde65bde0f26306a9304","16":"9e6d0fb856aa3ed09ed2","17":"3e8270714126556df5f8","18":"fba3f669f4f722eaa43f","19":"7c3fc469c111ce9c532a","20":"522227b68ff46538fb7a","21":"ef8ffd55e3148c3c2b39","22":"0547c3cccc9142054d6b","23":"d34f46af0e4536cbb422","24":"049583ac9143ebdf87fd","25":"927be6472c6aa1496bbb","26":"1408b484aa0a3b7f485d","27":"42b1f3c2ffd231a436ab","28":"d291592b1c25e59d5d9c","29":"052724597e082116d650","30":"a27813f2e11255ec48f2","31":"47f23188362fc05534fb","33":"a35e9eeb83e51b032914","34":"80c91bd7e607598d5942","35":"7d72307bdf87341d6df1","36":"515e9f62bd0a400fb9c8","37":"68d8cc28000fc1a16309","38":"921e962f751b7b86a713","39":"bec9378d5f8576be9117","40":"cbabfd30106b5d77201d","41":"2069f030fc8d99c98cef","42":"a065d81a0782d8e62f55","43":"e2c0139de430bbfe6427","44":"34f739fd634116adbee9","45":"35215c951b013fdca258","47":"a65c9b6b836818abe200","48":"5c5c3f4553e8ca21d8b4","49":"8e73eaca3c763768c75e","50":"1b0569a729d18c46a48c","51":"57311c6dc763ef6282cc","145":"88386d60a2f7e928323d","146":"3d1dae9efa606cba101a","147":"200dc79743c4db4b2802","148":"4b344f866e5f42bc1ab0","149":"41872a00d0ef7602fd4f","150":"09ef32eae69d1afd60dd","151":"4667c11d2c41ba8e3ec9","152":"2c1484665943003006d7","153":"954bf64f5c9115287118","154":"0141f22b61729f0a500a","155":"f6b6156f976b6af38813","156":"8d078d452a64c56afb22","157":"0d2be27257b2a70f2ce0","158":"9027a0561f8d63f55310","159":"f1e02e8a1b7b9670e512","160":"4b9866f215f5aa872179","161":"ae9aadbacb7ee35cca28","162":"5841900216a2f23f0043","163":"d0b7a5c7bb8bf8dcf57f","164":"6ae3d00ab077f1975a04","165":"2a37f1ecbda6fb3c2e19","166":"51201284326254ee92f7","167":"4b32340cb81b82b0cfb4","168":"1fb1d6a1de46c45865f7","169":"4e628bca1d6c82c6a789","170":"4930d9340daf5a6849fd","171":"8cd3a33a4dee554e77c2","172":"fe27645f449b09818659","173":"478f45758cbd846664c3","174":"003852f37177e90967d5","175":"6fb65a574d189feff882","176":"50896a38ffb249d1dd5b","177":"908adad170923b839b5f","326":"574d5360df530adcb0ba"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"175":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"1":"product-option-chain-position-selectable~product-option-color-inline~product-option-color-selectable~ec876204","2":"splidejs-splide","3":"tom-select","5":"adyen-adyen-web","33":"cart-modify-option-color","34":"cart-modify-option-custom-image","35":"cart-modify-option-custom-text","36":"cart-modify-option-glass-reversed","37":"cart-modify-option-material-canvas","38":"cart-modify-option-material-color","39":"cart-modify-option-model","40":"cart-modify-option-model-size","41":"cart-modify-option-pack","42":"cart-modify-option-size","43":"cart-modify-option-support-color","44":"cart-modify-option-tissue","45":"cart-modify-option-tissue-drop","47":"header-cart-general","48":"header-cart-item-general","49":"header-cart-item-image-zoom","50":"header-cart-voucher","51":"header-left-menu-v2","145":"pinch-zoom-js","146":"popup-personalized-text","147":"product-option-chain-position-selectable","148":"product-option-color-inline","149":"product-option-color-selectable","150":"product-option-custom-image-inline","151":"product-option-custom-image-selectable","152":"product-option-custom-text-inline","153":"product-option-custom-text-selectable","154":"product-option-frame-inline","155":"product-option-glass-reversed-inline","156":"product-option-material-color-inline","157":"product-option-model-inline","158":"product-option-model-size-inline","159":"product-option-motorbike-kit-selectable","160":"product-option-orientation-inline","161":"product-option-pack-inline","162":"product-option-pack-selectable","163":"product-option-size-inline-selectable","164":"product-option-size-multiple-selectable","165":"product-option-size-selectable","166":"product-option-size-single-value","167":"product-option-size-wallpaper","168":"product-option-support-color-selectable","169":"product-option-tissue-drop-selectable","170":"product-option-tissue-selectable","171":"product-option-vinyl-rug-format-inline","172":"product-page-ar-tool","173":"product-tool-wallpaper-calculator","174":"swiper","175":"vendors~product-option-material-color-inline","176":"vertex-filters-post-render-dynamic","177":"vertex-general-combination-suggestions-dynamic"}[chunkId]||chunkId) + ".20261103_" + {"1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","145":"31d6cfe0d16ae931b73c","146":"31d6cfe0d16ae931b73c","147":"31d6cfe0d16ae931b73c","148":"31d6cfe0d16ae931b73c","149":"31d6cfe0d16ae931b73c","150":"31d6cfe0d16ae931b73c","151":"31d6cfe0d16ae931b73c","152":"31d6cfe0d16ae931b73c","153":"31d6cfe0d16ae931b73c","154":"31d6cfe0d16ae931b73c","155":"31d6cfe0d16ae931b73c","156":"31d6cfe0d16ae931b73c","157":"31d6cfe0d16ae931b73c","158":"31d6cfe0d16ae931b73c","159":"31d6cfe0d16ae931b73c","160":"31d6cfe0d16ae931b73c","161":"31d6cfe0d16ae931b73c","162":"31d6cfe0d16ae931b73c","163":"31d6cfe0d16ae931b73c","164":"31d6cfe0d16ae931b73c","165":"31d6cfe0d16ae931b73c","166":"31d6cfe0d16ae931b73c","167":"31d6cfe0d16ae931b73c","168":"31d6cfe0d16ae931b73c","169":"31d6cfe0d16ae931b73c","170":"31d6cfe0d16ae931b73c","171":"31d6cfe0d16ae931b73c","172":"31d6cfe0d16ae931b73c","173":"31d6cfe0d16ae931b73c","174":"31d6cfe0d16ae931b73c","175":"3dd7e25e47e53f3b4a62","176":"31d6cfe0d16ae931b73c","177":"31d6cfe0d16ae931b73c","326":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					reject(err);
 				};
 				linkTag.href = fullhref;
 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/build/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
